import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import CountUp from "react-countup";
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Breadcrumbs from "../common/breadcrumbs";
import Aos from "aos";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import Header from "../common/header";
import BASE_URL from '../../config';
import { Modal, Button, Form} from "react-bootstrap";
import axios from 'axios';
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLanguage } from "../../core/context/LanguageContext";

const BecamePartner = () => {
  const { translations } = useLanguage();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    managerName: "",
    phoneNumber: "",
    capacity: "",
    email:"",
    city: "",
    address: "",
  });

  // Gérer les changements de champ du formulaire
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/api/agencyRequests`, formData);
      console.log('Réponse du backend:', response);

      if (response.status === 201) {
        toast.success("Agency request created successfully!");  // Affiche un toast de succès
        setShowModal(false);  // Ferme le modal après la soumission
      } else {
        toast.error("Failed to create agency request.");  // Affiche un toast d'erreur
      }
    } catch (error) {
      console.error('Erreur de connexion ou de requête:', error);
      toast.error("An error occurred during submission.");  // Affiche un toast d'erreur
    }
  };



  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  return (
    <>
       <Header />
      {/* Breadcrumb Section */}
      <Breadcrumbs
        title={translations.joinUs.breadcrumbs.title}
        subtitle={translations.joinUs.breadcrumbs.subtitle}
      />
      {/* Helmet Meta Tags */}
      <Helmet>
        <title>{translations.joinUs.helmet.title}</title>
        <meta name="description" content={translations.joinUs.helmet.description} />
        <link rel="canonical" href="https://cardnd.com/join-us" />
      </Helmet>

      <section className="section about-sec">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6" data-aos="fade-down">

              <div className="about-img">
                <div
                  className="about-exp"
                  style={{ paddingRight: "50px", display: "inline-block" }}
                >
                  <span>{translations.joinUs.about.tagline}</span>
                </div>
                <div>
                </div>
                <div className="abt-img" >
                  <ImageWithBasePath
                    src="assets/img/about-us.png"
                    className="img-fluid"
                    alt="About us"
                  />
                </div>
              </div>
            </div>


            <div className="col-lg-6" data-aos="fade-down">
              <div className="about-content">
                <div className="d-flex justify-content-end">
                  <Button variant="primary" onClick={() => setShowModal(true)}>
                    {translations.joinUs.about.buttonText}
                  </Button>
                </div>
                <h6>{translations.joinUs.about.sectionTitle}</h6>
                <h2>{translations.joinUs.about.mainTitle}</h2>
                {translations.joinUs.about.description.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
                <div className="row">
                  <div className="col-md-6">
                    <ul>
                      {translations.joinUs.about.features.left.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul>
                      {translations.joinUs.about.features.right.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            </div>
        </div>

        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{translations.joinUs.form.formTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
            <Form.Group controlId="formManagerName" className="mb-3">
            <Form.Label>
              {translations.joinUs.form.managerNameLabel}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder={translations.joinUs.form.managerNamePlaceholder}
              name="managerName"
              value={formData.managerName}
              onChange={handleInputChange}
            />
          </Form.Group>

            <Form.Group controlId="formEmail" className="mb-3">
              <Form.Label>{translations.joinUs.form.emailLabel}</Form.Label>
              <Form.Control
                type="email"
                placeholder={translations.joinUs.form.emailPlaceholder}
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group controlId="formPhoneNumber" className="mb-3">
              <Form.Label>
                {translations.joinUs.form.phoneNumberLabel}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={translations.joinUs.form.phoneNumberPlaceholder}
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group controlId="formCapacity" className="mb-3">
              <Form.Label>{translations.joinUs.form.capacityLabel}</Form.Label>
              <Form.Control
                type="number"
                placeholder={translations.joinUs.form.capacityPlaceholder}
                name="capacity"
                value={formData.capacity}
                onChange={handleInputChange}
              />
            </Form.Group>
              <Form.Group controlId="formCity" className="mb-3">
                <Form.Label>{translations.joinUs.form.selectCity}</Form.Label>
                <Form.Control
                  as="select"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>
                  {translations.joinUs.form.selectCity}
                  </option>
                  <option value="Casablanca">Casablanca</option>
                  <option value="Rabat">Rabat</option>
                  <option value="Fes">Fes</option>
                  <option value="Marrakech">Marrakech</option>
                  <option value="Tangier">Tangier</option>
                  <option value="Agadir">Agadir</option>
                  <option value="Meknes">Meknes</option>
                  <option value="Oujda">Oujda</option>
                  <option value="Kenitra">Kenitra</option>
                  <option value="Tetouan">Tetouan</option>
                  <option value="Safi">Safi</option>
                  <option value="Temara">Temara</option>
                  <option value="Mohammedia">Mohammedia</option>
                  <option value="Khouribga">Khouribga</option>
                  <option value="El Jadida">El Jadida</option>
                  <option value="Nador">Nador</option>
                  <option value="Beni Mellal">Beni Mellal</option>
                  <option value="Khemisset">Khemisset</option>
                  <option value="Ksar El Kebir">Ksar El Kebir</option>
                  <option value="Larache">Larache</option>
                  <option value="Guelmim">Guelmim</option>
                  <option value="Berrechid">Berrechid</option>
                  <option value="Khenifra">Khenifra</option>
                  <option value="Berkane">Berkane</option>
                  <option value="Taourirt">Taourirt</option>
                  <option value="Sefrou">Sefrou</option>
                  <option value="Settat">Settat</option>
                  <option value="Salé">Salé</option>
                  <option value="Sidi Kacem">Sidi Kacem</option>
                  <option value="Youssoufia">Youssoufia</option>
                  <option value="Ouarzazate">Ouarzazate</option>
                  <option value="Taza">Taza</option>
                  <option value="Errachidia">Errachidia</option>
                  <option value="Oulad Teima">Oulad Teima</option>
                  <option value="Tiznit">Tiznit</option>
                  <option value="El Kelaa des Sraghna">El Kelaa des Sraghna</option>
                  <option value="Essaouira">Essaouira</option>
                  <option value="Chefchaouen">Chefchaouen</option>
                  <option value="Taroudant">Taroudant</option>
                  <option value="Oued Zem">Oued Zem</option>
                  <option value="Tifelt">Tifelt</option>
                  <option value="Ben Guerir">Ben Guerir</option>
                  <option value="Fkih Ben Salah">Fkih Ben Salah</option>
                  <option value="Sidi Slimane">Sidi Slimane</option>
                  <option value="Tarfaya">Tarfaya</option>
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formAddress" className="mb-3">
                <Form.Label>Your Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter address"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          {translations.joinUs.form.buttons.close}
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {translations.joinUs.form.buttons.submit}
        </Button>
      </Modal.Footer>
        </Modal>




      </section>
      {/* /About */}
      {/* services */}
      <section className="section facts-number">
        <div className="facts-left">
          <ImageWithBasePath
            src="assets/img/bg/facts-left.png"
            className="img-fluid"
            alt="facts left"
          />
        </div>
        <div className="facts-right">
          <ImageWithBasePath
            src="assets/img/bg/facts-right.png"
            className="img-fluid"
            alt="facts right"
          />
        </div>
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2 className="title text-white">{translations.aboutUs.facts.title}</h2>
            <p className="description text-white">

            </p>
          </div>
          {/* /Heading title */}
          <div className="counter-group">
            <div className="row">
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-heart.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={16000}
                          duration={3}
                          separator=","
                        />
                        K<br />
                      </h4>
                      <p> {translations.aboutUs.facts.data[0].description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-car.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={2547}
                          duration={3}
                          separator=","
                        />
                        +<br />
                      </h4>
                      <p>{translations.aboutUs.facts.data[1].description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-headphone.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={625}
                          duration={3}
                          separator=","
                        />
                        K+
                        <br />
                      </h4>
                      <p>{translations.aboutUs.facts.data[2].description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-history.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={200}
                          duration={3}
                          separator=","
                        />
                        K+
                        <br />
                      </h4>
                      <p>{translations.aboutUs.facts.data[3].description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section why-choose">
        <div className="choose-left">
          <ImageWithBasePath
            src="assets/img/bg/choose-left.png"
            className="img-fluid"
            alt="Why Choose Us"
          />
        </div>
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2>{translations.aboutUs.whyChooseUs.title}</h2>

          </div>
          {/* /Heading title */}
          <div className="why-choose-group">
            <div className="row">
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-black">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-user-check.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{translations.aboutUs.whyChooseUs.reasons[0].title}</h4>
                      <p>
                        {translations.aboutUs.whyChooseUs.reasons[0].description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-secondary">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-user-check.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{translations.aboutUs.whyChooseUs.reasons[1].title}</h4>
                      <p>
                        {translations.aboutUs.whyChooseUs.reasons[1].description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-primary">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-user-check.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{translations.aboutUs.whyChooseUs.reasons[2].title}</h4>
                      <p>
                        {translations.aboutUs.whyChooseUs.reasons[2].description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Why Choose Us */}
      {/* About us Testimonials */}
      {/* <section className="section about-testimonial testimonials-section">
        <div className="container"> */}
      {/* Heading title*/}
      {/* <div className="section-heading" data-aos="fade-down">
            <h2 className="title text-white">What People say about us? </h2>
            <p className="description text-white">
              Lorem Ipsum has been the industrys standard dummy text ever since
              the 1500s,
            </p>
          </div> */}
      {/* /Heading title */}
      {/* <div className="owl-carousel about-testimonials testimonial-group mb-0 owl-theme"> */}
      {/* /Carousel Item  */}
      {/* Carousel Item */}
      {/* <Slider {...settings}>
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="testimonial-item d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="quotes-head" />
                      <div className="review-box">
                        <div className="review-profile">
                          <div className="review-img">
                            <ImageWithBasePath
                              src={testimonial.image}
                              className="img-fluid"
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="review-details">
                          <h6>{testimonial.name}</h6>
                          <div className="list-rating">
                            <div className="list-rating-star">
                              {[...Array(Math.floor(testimonial.rating))].map(
                                (_, i) => (
                                  <i key={i} className="fas fa-star filled" />
                                )
                              )}
                            </div>
                            <p>
                              <span>({testimonial.rating})</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <p>{testimonial.review}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider> */}

      {/* /Carousel Item  */}
      {/* Carousel Item */}

      {/* /Carousel Item  */}
      {/* </div>
        </div>
      </section> */}
      {/* About us Testimonials */}
      <>
        {/* FAQ  */}
        <section className="section faq-section bg-light-primary">
          <div className="container">
            {/* Heading title*/}
            <div className="section-heading" data-aos="fade-down">
              <h2>{translations.aboutUs.faqs.title}</h2>
              <p>
                {translations.aboutUs.faqs.description}
              </p>
            </div>
            {/* /Heading title */}
            <div className="faq-info">
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqOne"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[0].question}

                  </Link>
                </h4>
                <div id="faqOne" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[0].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqTwo"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[1].question}

                  </Link>
                </h4>
                <div id="faqTwo" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[1].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqThree"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[2].question}

                  </Link>
                </h4>
                <div id="faqThree" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[2].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqFour"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[3].question}

                  </Link>
                </h4>
                <div id="faqFour" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[3].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqFive"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[4].question}

                  </Link>
                </h4>
                <div id="faqFive" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[4].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqSix"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[5].question}

                  </Link>
                </h4>
                <div id="faqSix" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[5].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqSeven"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[6].question}

                  </Link>
                </h4>
                <div id="faqSeven" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[6].answer}

                  </p>
                </div>
              </div>

              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqEight"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[7].question}

                  </Link>
                </h4>
                <div id="faqEight" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[7].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqNine"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[8].question}

                  </Link>
                </h4>
                <div id="faqNine" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[8].answer}

                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
<ToastContainer />

        {/* /FAQ */}
      </>
    </>
  );
};

export default BecamePartner;
